module.exports = __webpack_public_path__ + "img/recordModalBg.2c715317.png";